(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/pages/root/page.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/pages/root/page.js');
"use strict";


const {
  WidgetArea
} = svs.components.tb_ui_react.widget_area;
setGlobal('svs.ticketsValidate.pages.Root', () => React.createElement(WidgetArea, {
  areaName: "landingWidget"
}));

 })(window);